// extracted by mini-css-extract-plugin
module.exports = {"peopleSection":"styles_peopleSection__2pBeD","titleWithIcon":"styles_titleWithIcon__13xeF","infoIcon":"styles_infoIcon__2HV_9"};